export default "/institutions/cash-app.svg";